export enum USER_INTENTION_REQUEST_IDENTIFIERS {
  GET_USER_INTENTION_QUALIFICATION = 'intention.qualification.get'
}
